export default __webpack_public_path__ + "static/media/IMG_2950.3a8db77b.JPG";